import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, ShoppingCart, Package, Truck, Users, BarChart3,
  Settings, Bell, Search, ChevronDown, Menu, X, LogOut,
  TrendingUp, TrendingDown, AlertCircle, CheckCircle2, Clock, MapPin,
  ChevronRight, MoreHorizontal, Filter, Download, RefreshCw, 
  Construction, Boxes, FileText, Banknote, UserCheck, Star,
  CalendarDays, Activity, Eye, Edit3, Trash2, Upload
} from 'lucide-react';

// ─── Sidebar nav items ───────────────────────────────────────────────────────
const NAV_ITEMS = [
  { icon: LayoutDashboard, label: 'Dashboard', id: 'overview' },
  { icon: ShoppingCart, label: 'Pesanan', id: 'orders' },
  { icon: Package, label: 'Produk & Harga', id: 'products' },
  { icon: Truck, label: 'Armada & Pengiriman', id: 'deliveries' },
  { icon: Construction, label: 'Batching Plant', id: 'plants' },
  { icon: Users, label: 'Pelanggan', id: 'customers' },
  { icon: FileText, label: 'Quotation', id: 'quotations' },
  { icon: Banknote, label: 'Keuangan', id: 'finance' },
  { icon: BarChart3, label: 'Laporan', id: 'reports' },
];

const STATUS_CONFIG = {
  submitted: { label: 'Diajukan', cls: 'status-payment' },
  sales_review: { label: 'Review Sales', cls: 'status-batching' },
  approved: { label: 'Disetujui', cls: 'status-approved' },
  batching: { label: 'Batching', cls: 'status-batching' },
  dispatched: { label: 'Dikirim', cls: 'status-dispatched' },
  completed: { label: 'Selesai', cls: 'status-completed' },
  cancelled: { label: 'Dibatalkan', cls: 'status-danger' },
};

export default function AdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeView, setActiveView] = useState('overview');
  const [notifOpen, setNotifOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={`ad-root ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* ─── SIDEBAR ───────────────────────────────────────── */}
      <aside className="ad-sidebar">
        <div className="ad-sb-head">
          <div className="ad-sb-logo">
            <div className="ad-sb-logo-mark">SB</div>
            {sidebarOpen && (
              <div className="ad-sb-logo-text">
                <div className="ad-sb-logo-top">SBB Admin</div>
                <div className="ad-sb-logo-bot">v2.0 · Operations</div>
              </div>
            )}
          </div>
          <button className="ad-sb-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>

        <nav className="ad-sb-nav">
          <div className="ad-sb-section">MENU UTAMA</div>
          {NAV_ITEMS.map(item => (
            <button 
              key={item.id} 
              className={`ad-nav-item-btn ${activeView === item.id ? 'active' : ''}`}
              onClick={() => setActiveView(item.id)}
            >
              <span className="ad-nav-icon"><item.icon size={18} /></span>
              {sidebarOpen && <span className="ad-nav-label">{item.label}</span>}
            </button>
          ))}
        </nav>

        <div className="ad-sb-user">
          <div className="ad-sb-avatar">AH</div>
          {sidebarOpen && (
            <div className="ad-sb-user-info">
              <div className="ad-sb-user-name">Ahmad Hidayat</div>
              <div className="ad-sb-user-role">Super Admin</div>
            </div>
          )}
          {sidebarOpen && (
            <button className="ad-sb-logout" onClick={() => navigate('/admin')} title="Logout">
              <LogOut size={16} />
            </button>
          )}
        </div>
      </aside>

      {/* ─── MAIN CONTENT ──────────────────────────────────── */}
      <div className="ad-main">
        {/* Topbar */}
        <header className="ad-topbar">
          <div className="ad-topbar-left">
            <div className="ad-breadcrumb">
              <span>Admin</span>
              <ChevronRight size={14} />
              <span className="ad-bc-active">{NAV_ITEMS.find(n => n.id === activeView)?.label}</span>
            </div>
            <h1 className="ad-page-title">{NAV_ITEMS.find(n => n.id === activeView)?.label} Management</h1>
          </div>

          <div className="ad-topbar-right">
            <div className="ad-date-chip">
              <CalendarDays size={14} />
              <span>{new Date().toLocaleDateString('id-ID', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}</span>
            </div>
            <div className="ad-profile-wrap">
              <button className="ad-profile-btn" onClick={() => setProfileOpen(!profileOpen)}>
                <div className="ad-profile-av">AH</div>
                <span>Admin</span>
                <ChevronDown size={14} />
              </button>
            </div>
          </div>
        </header>

        {/* ─── CONTENT AREA ─────────────────────────────────── */}
        <div className="ad-content">
          {activeView === 'overview' && <OverviewTab />}
          {activeView === 'orders' && <OrdersView />}
          {activeView === 'products' && <ProductsView />}
          {['deliveries', 'plants', 'customers', 'quotations', 'finance', 'reports'].includes(activeView) && (
            <div className="ad-card" style={{padding:'100px',textAlign:'center'}}>
              <Construction size={48} color="var(--ad-primary)" style={{marginBottom:'20px'}} />
              <h2>Halaman Sedang Dikembangkan</h2>
              <p>Fitur {activeView} akan tersedia pada pembaruan berikutnya.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─── Views ─────────────────────────────────────────────────────────────── */

function OverviewTab() {
  return (
    <>
      <div className="ad-alert-bar">
        <Activity size={14} />
        <span>Sistem berjalan normal · 3 armada aktif di lapangan · Pembaruan terakhir: 09:47 WIB</span>
        <button className="ad-alert-refresh"><RefreshCw size={12} /></button>
      </div>
      <div className="ad-stats-grid">
        {[
          { label: 'Pesanan Hari Ini', value: '24', icon: ShoppingCart, color: 'blue' },
          { label: 'Pendapatan Bulan Ini', value: 'Rp 2,4M', icon: Banknote, color: 'green' },
          { label: 'Pengiriman Aktif', value: '8', icon: Truck, color: 'orange' },
          { label: 'Leads Baru', value: '15', icon: UserCheck, color: 'purple' },
        ].map((s, i) => (
          <div key={i} className={`ad-stat-card ad-stat-${s.color}`}>
            <div className="ad-sc-top"><div className="ad-sc-icon"><s.icon size={22} /></div></div>
            <div className="ad-sc-value">{s.value}</div>
            <div className="ad-sc-label">{s.label}</div>
          </div>
        ))}
      </div>
      <div className="ad-mid-grid">
        <div className="ad-card ad-chart-card">
          <div className="ad-card-head"><h3>Analitik Penjualan</h3></div>
          <div className="ad-chart-placeholder" style={{height:'200px', display:'flex', alignItems:'flex-end', gap:'10px', padding:'20px'}}>
             {[40,60,45,90,70,50,80].map((h, i) => <div key={i} style={{flex:1, height:`${h}%`, background:'var(--ad-primary)', borderRadius:'4px 4px 0 0'}} />)}
          </div>
        </div>
        <div className="ad-card">
          <div className="ad-card-head"><h3>Tugas Hari Ini</h3></div>
          <div style={{padding:'20px'}}>
            <div className="ad-notif-item">● Konfirmasi 3 quotation tertunda</div>
            <div className="ad-notif-item">● Atur jadwal pengiriman SBB-0241</div>
            <div className="ad-notif-item">● Verifikasi pembayaran PT Maju Jaya</div>
          </div>
        </div>
      </div>
    </>
  );
}

function OrdersView() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  
  // Filters
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/orders`);
      const data = await response.json();
      setOrders(data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const fetchOrderDetail = async (id) => {
    setDetailLoading(true);
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/orders/${id}`);
      const data = await response.json();
      setSelectedOrder(data);
    } catch (err) { console.error(err); }
    finally { setDetailLoading(false); }
  };

  const updateStatus = async (id, newStatus) => {
    try {
      await fetch(`${import.meta.env.VITE_API_URL}/api/admin/orders/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      });
      fetchOrders();
    } catch (err) { console.error(err); }
  };
  const filteredOrders = orders.filter(o => {
    const date = new Date(o.created_at);
    const from = dateFrom ? new Date(dateFrom) : null;
    const to = dateTo ? new Date(dateTo) : null;
    
    if (from && date < from) return false;
    if (to) {
      const toAdjusted = new Date(to);
      toAdjusted.setHours(23, 59, 59, 999);
      if (date > toAdjusted) return false;
    }
    if (statusFilter !== 'all' && o.status !== statusFilter) return false;
    return true;
  });

  const exportToCSV = () => {
    // SAP ERP Template Columns
    const headers = [
      "Order_Number",
      "Order_Date",
      "Order_Time",
      "Customer_Name",
      "Customer_Phone",
      "Project_Name",
      "Project_Address",
      "Estimated_Total",
      "Currency",
      "Status",
      "Plant"
    ];

    const rows = filteredOrders.map(o => {
      const dt = new Date(o.created_at);
      return [
        o.order_number,
        dt.toISOString().split('T')[0],
        dt.toTimeString().split(' ')[0],
        `"${o.customer_name}"`,
        o.phone,
        `"${o.project_name}"`,
        `"${o.project_address.replace(/"/g, '""')}"`,
        o.estimated_total,
        "IDR",
        o.status,
        o.plant_name || "N/A"
      ];
    });

    const csvContent = [
      headers.join(","),
      ...rows.map(r => r.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `SBB_Orders_Export_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="ad-card ad-table-card">
      <div className="ad-card-head">
        <div><h3>Kelola Pesanan</h3><p>Daftar semua pesanan masuk</p></div>
        <div className="ad-card-actions">
          <button className="ad-btn-export" onClick={exportToCSV}>
            <Download size={14}/> Export to SAP (CSV)
          </button>
          <button className="ad-btn-ghost" onClick={fetchOrders}><RefreshCw size={14}/> Refresh</button>
        </div>
      </div>

      <div className="ad-filters-bar">
        <div className="ad-filter-group">
          <label>Dari Tanggal</label>
          <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </div>
        <div className="ad-filter-group">
          <label>Sampai Tanggal</label>
          <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </div>
        <div className="ad-filter-group">
          <label>Status</label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="all">Semua Status</option>
            {Object.keys(STATUS_CONFIG).map(k => (
              <option key={k} value={k}>{STATUS_CONFIG[k].label}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="ad-table-wrap">
        <table className="ad-table">
          <thead>
            <tr>
              <th>Order #</th>
               <th>Waktu Pesan</th>
               <th>Pelanggan</th>
               <th>Proyek</th>
              <th>Total</th>
              <th>Status</th>
              <th>Update Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map(o => (
               <tr key={o.id}>
                 <td><strong>{o.order_number}</strong></td>
                 <td>
                   <div style={{ fontSize: '13px', fontWeight: '700' }}>{new Date(o.created_at).toLocaleDateString('id-ID')}</div>
                   <div style={{ fontSize: '11px', color: '#64748b' }}>{new Date(o.created_at).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })}</div>
                 </td>
                 <td>{o.customer_name}</td>
                 <td>{o.project_name}</td>
                 <td>Rp {parseInt(o.estimated_total).toLocaleString('id-ID')}</td>
                 <td><span className={`ad-status ${STATUS_CONFIG[o.status]?.cls}`}>{STATUS_CONFIG[o.status]?.label}</span></td>
                 <td>
                   <select 
                     value={o.status} 
                     onChange={(e) => updateStatus(o.id, e.target.value)}
                     className="ad-select-sm"
                   >
                     {Object.keys(STATUS_CONFIG).map(k => (
                       <option key={k} value={k}>{STATUS_CONFIG[k].label}</option>
                     ))}
                   </select>
                 </td>
                 <td>
                   <button 
                     className="ad-row-action" 
                     onClick={() => fetchOrderDetail(o.id)}
                     title="Lihat Detail"
                   >
                     <Eye size={16} />
                   </button>
                 </td>
               </tr>
             ))}
           </tbody>
         </table>
       </div>
 
       {selectedOrder && (
         <OrderDetailModal 
           order={selectedOrder} 
           onClose={() => setSelectedOrder(null)} 
           onUpdateStatus={updateStatus}
         />
       )}
     </div>
   );
 }
 
 function OrderDetailModal({ order, onClose, onUpdateStatus }) {
   return (
     <div className="ad-modal-overlay" onClick={onClose}>
       <div className="ad-modal-content" onClick={e => e.stopPropagation()}>
         <div className="ad-modal-head">
           <div>
             <h3>Detail Pesanan #{order.order_number}</h3>
             <p>{new Date(order.created_at).toLocaleString('id-ID')}</p>
           </div>
           <button className="ad-modal-close" onClick={onClose}><X size={20} /></button>
         </div>
 
         <div className="ad-modal-body">
           <div className="ad-detail-grid">
             <div className="ad-detail-section">
               <h4>Informasi Pelanggan</h4>
               <div className="ad-detail-info">
                 <div className="ad-di-row"><span>Nama:</span> <strong>{order.customer_name}</strong></div>
                 <div className="ad-di-row"><span>WhatsApp:</span> <strong>{order.phone}</strong></div>
                 <div className="ad-di-row"><span>Email:</span> <strong>{order.email}</strong></div>
               </div>
             </div>
 
             <div className="ad-detail-section">
               <h4>Detail Proyek</h4>
               <div className="ad-detail-info">
                 <div className="ad-di-row"><span>Proyek:</span> <strong>{order.project_name}</strong></div>
                 <div className="ad-di-row"><span>Alamat:</span> <strong>{order.project_address}</strong></div>
                 <div className="ad-di-row"><span>Status:</span> <span className={`ad-status ${STATUS_CONFIG[order.status]?.cls}`}>{STATUS_CONFIG[order.status]?.label}</span></div>
               </div>
             </div>
           </div>
 
           <div className="ad-detail-items">
             <h4>Item Pesanan</h4>
             <table className="ad-mini-table">
               <thead>
                 <tr>
                   <th>Produk</th>
                   <th>Volume</th>
                   <th>Harga</th>
                   <th className="text-right">Subtotal</th>
                 </tr>
               </thead>
               <tbody>
                 {order.items?.map((item, idx) => (
                   <tr key={idx}>
                     <td>
                       <div className="ad-it-name">{item.product_name}</div>
                       <div className="ad-it-meta">{item.product_category} · {item.truck_type}</div>
                     </td>
                     <td>{item.volume_m3} m³</td>
                     <td>Rp {parseInt(item.unit_price).toLocaleString('id-ID')}</td>
                     <td className="text-right">Rp {parseInt(item.subtotal).toLocaleString('id-ID')}</td>
                   </tr>
                 ))}
               </tbody>
               <tfoot>
                 <tr>
                   <td colSpan="3" className="text-right"><strong>Total Estimasi</strong></td>
                   <td className="text-right"><strong>Rp {parseInt(order.estimated_total).toLocaleString('id-ID')}</strong></td>
                 </tr>
               </tfoot>
             </table>
           </div>
 
           <div className="ad-modal-actions">
             <div className="ad-status-change">
               <span>Ubah Status:</span>
               <select 
                 value={order.status} 
                 onChange={(e) => {
                   onUpdateStatus(order.id, e.target.value);
                   onClose();
                 }}
                 className="ad-select-md"
               >
                 {Object.keys(STATUS_CONFIG).map(k => (
                   <option key={k} value={k}>{STATUS_CONFIG[k].label}</option>
                 ))}
               </select>
             </div>
             <button className="ad-btn-close" onClick={onClose}>Tutup</button>
           </div>
         </div>
       </div>
     </div>
   );
 }

function ProductsView() {
  const [products, setProducts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/products?include_inactive=true`);
      const data = await response.json();
      setProducts(data);
    } catch (err) { console.error(err); }
  };

  const onFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleUpdate = async (id) => {
    try {
      const formData = new FormData();
      formData.append('price_per_m3', newPrice);
      if (selectedFile) formData.append('image', selectedFile);

      await fetch(`${import.meta.env.VITE_API_URL}/api/admin/products/${id}`, {
        method: 'PATCH',
        body: formData
      });
      setEditingId(null);
      setSelectedFile(null);
      setPreviewUrl(null);
      fetchProducts();
    } catch (err) { console.error(err); }
  };

  return (
    <div className="ad-card ad-table-card">
      <div className="ad-card-head">
        <div><h3>Katalog & Harga</h3><p>Atur harga beton per wilayah</p></div>
      </div>
      <div className="ad-table-wrap">
        <table className="ad-table">
          <thead>
            <tr>
              <th>Foto</th>
              <th>Produk</th>
              <th>Kategori</th>
              <th>Mutu</th>
              <th>Harga Dasar (/m³)</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id}>
                <td>
                  <div className="ad-prod-img-wrap">
                    <img 
                      src={editingId === p.id && previewUrl ? previewUrl : (p.image_url ? `${import.meta.env.VITE_API_URL}${p.image_url}` : 'https://placehold.co/100x100?text=No+Image')} 
                      alt={p.name} 
                    />
                    {editingId === p.id && (
                      <label className="ad-img-upload-overlay">
                        <Upload size={14} />
                        <input type="file" hidden onChange={onFileSelect} accept="image/*" />
                      </label>
                    )}
                  </div>
                </td>
                <td><strong>{p.name}</strong></td>
                <td>{p.category}</td>
                <td><span className="badge-mutu">{p.strength_class}</span></td>
                <td>
                  {editingId === p.id ? (
                    <input 
                      type="number" 
                      value={newPrice} 
                      onChange={e => setNewPrice(e.target.value)}
                      className="ad-input-sm"
                    />
                  ) : (
                    `Rp ${parseInt(p.price_per_m3).toLocaleString('id-ID')}`
                  )}
                </td>
                <td><span className={`ad-status ${p.status === 'active' ? 'status-approved' : 'status-danger'}`}>{p.status}</span></td>
                <td>
                  {editingId === p.id ? (
                    <button className="btn-save" onClick={() => handleUpdate(p.id)}>Simpan</button>
                  ) : (
                    <button className="ad-row-action" onClick={() => { setEditingId(p.id); setNewPrice(p.price_per_m3); }}><Edit3 size={16} /></button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
